export const WORKFORCE_GROUP_DELETED = 'Workforce group deleted';
export const WORKFORCE_GROUP_CREATED = 'Workforce group created';
export const WORKFORCE_GROUP_FIELD_CREATED = 'Field created';
export const WORKFORCE_GROUP_FIELD_DELETED = 'Field deleted';
